var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.028,
    height: 20.078,
    viewBox: "0 0 29.028 20.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5841",
    "data-name": "Group 5841",
    transform: "translate(1 1.148)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4693",
    "data-name": "Group 4693",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32178",
    "data-name": "Path 32178",
    d: "M26.6,139.941h0l-7.555-7.519a1.446,1.446,0,0,0-2.04,2.05l5.073,5.048H1.446a1.446,1.446,0,0,0,0,2.892H22.079l-5.072,5.048a1.446,1.446,0,0,0,2.04,2.05L26.6,141.99h0A1.447,1.447,0,0,0,26.6,139.941Z",
    transform: "translate(0 -132)",
    fill: "#231f20",
    stroke: "#f1f1f1",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessRight);
export default __webpack_public_path__ + "static/media/business-right.8804ae1823cc5ca237f6434169007594.svg";
export { ForwardRef as ReactComponent };